export const normalizeMix=plan=>{
  const next=structuredClone(plan);
  const legacy=next.sales_basis!=='monthly'&&!next.products.some(p=>Array.isArray(p.monthly_units));
  if(legacy&&!next.previous_sales_reference){
    next.previous_sales_reference={name:next.name||'Versão anual anterior',mix_mode:next.mix_mode||'units',total_units:next.mix_mode==='percentages'?next.total_units:next.products.reduce((s,p)=>s+(p.units||0),0),products:next.products.map(p=>({id:p.id,name:p.name,units:p.units||0,share:p.share||0})),monthly_weights:next.monthly_weights||Array(12).fill(1)};
  }
  next.sales_basis='monthly';next.mix_mode='monthly';
  next.products=next.products.map(p=>({...p,monthly_units:legacy?Array(12).fill(null):(p.monthly_units||Array(12).fill(null))}));
  next.products.forEach(p=>p.units=p.monthly_units.reduce((s,q)=>s+(q??0),0));
  next.total_units=next.products.reduce((s,p)=>s+p.units,0);
  next.products.forEach(p=>p.share=next.total_units?p.units/next.total_units*100:0);
  return next;
};

export const monthlyStatus=plan=>{
  const defined=plan?.products?.reduce((sum,p)=>sum+(p.monthly_units||[]).filter(q=>q!==null&&q!==undefined).length,0)||0;
  return {defined,complete:defined===72,label:defined===0?'Previsão mensal por preencher':defined===72?'Previsão mensal preenchida':`Previsão parcial · ${defined}/72 quantidades preenchidas`};
};